import { logEvent } from 'firebase/analytics';
import { analyticsPromise } from '../Firebase';
import { getSeoForPath, siteConfig } from '../config/site';

let lastTrackedPath = '';

function withAnalytics(callback) {
  if (typeof window === 'undefined') {
    return;
  }

  analyticsPromise.then((analytics) => {
    if (analytics) {
      callback(analytics);
    }
  });
}

export function trackPageView(path) {
  if (typeof window === 'undefined' || path === lastTrackedPath) {
    return;
  }

  lastTrackedPath = path;

  withAnalytics((analytics) => {
    const pathname = path.split('?')[0] || '/';
    const seo = getSeoForPath(pathname);

    logEvent(analytics, 'page_view', {
      page_title: `${seo.title} | ${siteConfig.name}`,
      page_location: window.location.href,
      page_path: path,
    });
  });
}

export function trackWebVital(metric) {
  withAnalytics((analytics) => {
    logEvent(analytics, metric.name, {
      event_category: 'Web Vitals',
      event_label: metric.id,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      non_interaction: true,
    });
  });
}
